import api from './api';

export async function changePassword(payload) {
  const { data } = await api.put('/user/change-password', payload);
  return data;
}
